<section class="products-hero">
    <div class="container">
        <p class="section-kicker">Our Products</p>
        <h1>The BunnyCRM product suite</h1>
        <p>BunnyCRM gives teams connected modules for marketing, sales, support, and documents — all
            built around one customer record, so campaigns, deals, tickets, and files stay together
            instead of spread across separate tools. Notes, Action Items, and Drive also double as your
            own private space for personal use.</p>
    </div>
</section>

<section class="products-showcase">
    <div class="container">
        <div class="products-grid">
            @for (product of products; track product.slug; let i = $index) {
            <article class="product-card" data-reveal [style.--d]="(i * 0.08) + 's'" tabindex="0" role="link"
                [attr.aria-label]="product.name + ' — more details'" (click)="routeTo('products/' + product.slug)"
                (keydown.enter)="routeTo('products/' + product.slug)">
                <div class="product-card-media">
                    <img src="{{product.photo01}}" alt="{{product.photo01Alt}}" width="400" height="200" loading="lazy">
                </div>
                <div class="product-card-body">
                    <h2>{{product.name}}</h2>
                    <p [innerHTML]="product.description"></p>
                    <div class="product-card-actions">
                        <span class="product-link">
                            More details <span class="product-link-arrow" aria-hidden="true">→</span>
                        </span>
                        <a class="product-link product-link-muted" [href]="product.link" target="_blank"
                            rel="noopener noreferrer" (click)="$event.stopPropagation()">
                            Visit bunnycrm.com <span class="product-link-arrow" aria-hidden="true">↗</span>
                        </a>
                    </div>
                </div>
            </article>
            }
        </div>
    </div>
</section>
